
import {BackgroundImage} from "./background-image-generic";

for (const element of document.querySelectorAll('.background-image')) {
  element.instance = new BackgroundImage('background-image', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/background-image/background-image.js